<template>
  <div class="terms-dialog" >
    <v-tabs fixed-tabs v-model="selected" >
      <v-tab href="#privacy" ripple>
        {{$tf('PrivacyPolicy')}}
      </v-tab>
      <v-tab href="#terms" ripple>
        {{$tf('Terms and Conditions')}}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selected" >
      <v-tab-item id="privacy" >
        <iframe :src="`/static/privacy/${locale}.html`" frameborder="0" width="100%" height="100%" />
      </v-tab-item>
      <v-tab-item id="terms" >
        <iframe :src="`/static/terms/${locale}.html`" frameborder="0" style="overflow:hidden;height:100%;width:100%" height="100%" width="100%" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
  import IdoniaLocales from '~/locales'

  export default {
    name: 'dialog-terms-and-policy',
    props: {
      tab: {
        type: String,
        default: 'privacy'
      }
    },
    data () {
      return {
        selected: this.tab
      }
    },
    computed: {
      locale () {
        return (IdoniaLocales.parseLocale(this.$i18n.locale) || IdoniaLocales.defaultLocale).code
      }
    }
  }
</script>

<style lang="scss">
  .terms-dialog .tabs__wrapper {
    margin-left: 0px !important;
  }
  #register-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #register-dialog .card {
    width: 600px;
    min-height: 505px;
  }

  #register-dialog #politica {
    position: relative;
  }

  #register-dialog .check-layout {
    position: absolute;
    top: 24px;
    left: 28px;
  }

  #privacy, #terms {
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }

  .terms-dialog iframe {
    height: 100%;
    width: 100%;
  }

  .terms-dialog,
  .tabs__content {
    height: 100%;
  }
  .tabs__items {
    height: calc(100% - 48px);
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogTermsAndPolicy.vue